import { defineMessages } from 'react-intl';

export const PICTURE_GALLERY_KEY = '@@pictureGallery';

export const LOCALIZED_STRINGS = defineMessages({
    CurrentValueOfMaxValue: {
        id: 'Profile.Components.CurrentValueOfMaxValue',
        defaultMessage: '{value} of {maxValue}',
    },
    ThumbnailAlt: {
        id: 'Profile.Components.PictureGallery.PictureAltWithCount',
        defaultMessage: 'Show picture {number} of {count} for {firstName} {lastName}',
    },
    Previous: {
        id: 'Profile.Components.PictureGallery.Previous',
        defaultMessage: 'Previous picture',
    },
    Next: {
        id: 'Profile.Components.PictureGallery.Next',
        defaultMessage: 'Next picture',
    },
    Close: {
        id: 'Profile.Components.PictureGallery.Close',
        defaultMessage: 'Close gallery',
    },
});
